import { render, staticRenderFns } from "./DurationLogin.vue?vue&type=template&id=197886ab&scoped=true&"
import script from "./DurationLogin.vue?vue&type=script&lang=js&"
export * from "./DurationLogin.vue?vue&type=script&lang=js&"
import style0 from "./DurationLogin.vue?vue&type=style&index=0&id=197886ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197886ab",
  null
  
)

export default component.exports